import React from 'react';

import Menu from 'ui-library/menus/Menu';
import {OptionData} from 'ui-library/menus/MenuConstants';
import {immutableRemoveAt} from 'util/ImmutableListUtil';

import SearchableMenu, {SearchableMenuProps} from './SearchableMenu';

export interface SelectSearchableMenuProps {
  /** Props to be spread on the underlying SearchableMenu. */
  menuProps?: Partial<SearchableMenuProps>;
  noneSelectedMessage: React.ReactNode;
  optionDatas: Array<OptionData>;
  onSelect: (selectedValues: Array<string>) => void;
  selectedValues: Array<string>;
  deselectValueAtIndex?: (idx: number) => void;
}

/**
 * A menu that allows selecting and deselecting multiple options, even in submenus.
 */
export default function SelectSearchableMenu(props: SelectSearchableMenuProps): JSX.Element {
  const deselectValueAtIndex =
    props.deselectValueAtIndex ??
    ((selectedValueIdx: number): void => {
      props.onSelect(immutableRemoveAt(props.selectedValues, selectedValueIdx));
    });

  return (
    <SearchableMenu
      width={Menu.WIDTHS.FULL}
      {...props.menuProps}
      selectedValue={props.selectedValues}
      scrollable={true}
      onSelect={(selectedValue) => {
        if (Array.isArray(selectedValue) && props.menuProps?.showSelectedAsChips) {
          props.onSelect(selectedValue);
        } else {
          const selectedValueIdx = props.selectedValues.indexOf(selectedValue);
          if (selectedValueIdx >= 0) {
            deselectValueAtIndex(selectedValueIdx);
          } else {
            props.onSelect([...props.selectedValues, selectedValue]);
          }
        }
      }}
      optionDatas={props.optionDatas}
      skipIconOverride={true}
    />
  );
}
